import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  align-items: center;
`;

export const Header = styled.View`
  width: 100%;
  height: ${RFPercentage(50)}px;
  justify-content: center;
  align-items: center;
  margin-top: -${RFPercentage(4)}px;
`;

export const Content = styled.View`
  padding: 0 24px;
  margin-top: -${RFPercentage(12)}px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  text-align: center;
`;

export const Description = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  text-align: center;
`;
